<template>
  <div class="access-denied">
    <div class="access-denied-container">
      <i class="fas fa-lock fa-4x text-danger mb-4"></i>
      <h1 class="mb-3">Accesso negato</h1>
      <p class="lead mb-4">
        Non hai i permessi necessari per accedere a questa pagina.
      </p>
    </div>
  </div>
</template>

<script>
import { useFormStore } from '../stores/formStore'

export default {
  name: 'AccessDenied',
  setup() {
    const store = useFormStore()

    const goToHome = () => {
      store.redirectToUserHome()
    }

    const logout = () => {
      store.logout()
    }

    return {
      goToHome,
      logout,
    }
  },
}
</script>

<style scoped>
.access-denied {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.access-denied-container {
  max-width: 500px;
  padding: 2rem;
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.fa-lock {
  color: #dc3545;
}

h1 {
  font-weight: 700;
  color: #343a40;
}

.lead {
  color: #6c757d;
}
</style>
